// extracted by mini-css-extract-plugin
export default {"container":"CreateTenant_container__Tps2N","card":"CreateTenant_card__Ix9Qd","title":"CreateTenant_title__VwIL1","subtitle":"CreateTenant_subtitle__oOlxj"};